// import {Gestionnaire, Partenaire, User, UserRole} from "./models";

// export const ROLES = [
//   {key: 'ROLE_USER', value: 'Utilisateur'},
//   {key: 'ROLE_ADMIN ', value: 'Administrateur'},
//   {key: 'ROLE_SUPER_ADMIN', value: 'Super Admin'},
// ];

export const partenaireColor = [
  {label: 'AXA France', couleur: '#00008f'},
  {label: 'MAIF', couleur: '#00a650'},
  {label: 'Allianz', couleur: '#003781'},
  {label: 'Groupama', couleur: '#00a19a'},
  {label: 'MACIF', couleur: '#e30613'},
];

export const mois = [
  {id: '1', code: 'Jan', libelle: 'Janvier'},
  {id: '2', code: 'Févr', libelle: 'Février'},
  {id: '3', code: 'Mars', libelle: 'Mars'},
  {id: '4', code: 'Avr', libelle: 'Avril'},
  {id: '5', code: 'Mai', libelle: 'Mai'},
  {id: '6', code: 'Juin', libelle: 'Juin'},
  {id: '7', code: 'Juil', libelle: 'Juillet'},
  {id: '8', code: 'Août', libelle: 'Août'},
  {id: '9', code: 'Sept', libelle: 'Septembre'},
  {id: '10', code: 'Oct', libelle: 'Octobre'},
  {id: '11', code: 'Nov', libelle: 'Novembre'},
  {id: '12', code: 'Dec', libelle: 'Décembre'},
]

// export const PARTENAIRES: Record<string, Partenaire> = {
//   axa: {id: 'axa', nom: 'AXA France', logo: 'AXA', couleur: '#00008f', email: 'gestion@axa.fr'},
//   maif: {id: 'maif', nom: 'MAIF', logo: 'MAIF', couleur: '#00a650', email: 'gestion@maif.fr'},
//   allianz: {id: 'allianz', nom: 'Allianz', logo: 'ALZ', couleur: '#003781', email: 'gestion@allianz.fr'},
//   groupama: {id: 'groupama', nom: 'Groupama', logo: 'GRP', couleur: '#00a19a', email: 'gestion@groupama.fr'},
//   macif: {id: 'macif', nom: 'MACIF', logo: 'MAC', couleur: '#e30613', email: 'gestion@macif.fr'},
// };
//
// export const GESTIONNAIRES: Gestionnaire[] = [
//   {id: 1, nom: 'Sophie Martin', email: 'sophie.martin@groupesurplus.com', role: 'Responsable Dossiers'},
//   {id: 2, nom: 'Laurent Dubois', email: 'laurent.dubois@groupesurplus.com', role: 'Gestionnaire Senior'},
//   {id: 3, nom: 'Marie Leroy', email: 'marie.leroy@groupesurplus.com', role: 'Gestionnaire'},
// ];

// export const USERS: User[] = [
//   {
//     id: 1,
//     email: 'admin@groupesurplus.com',
//     password: 'admin',
//     nom: 'Admin',
//     prenom: 'GSR',
//     role: UserRole.SUPER_ADMIN,
//     partenaire: null,
//     actif: true
//   },
//   {
//     id: 2,
//     email: 'gestionnaire@axa.fr',
//     password: 'axa123',
//     nom: 'Jean',
//     prenom: 'Dupont',
//     role: UserRole.ADMIN_PARTENAIRE,
//     partenaire: 'axa',
//     actif: true
//   },
//   {
//     id: 3,
//     email: 'user@axa.fr',
//     password: 'axa123',
//     nom: 'Marie',
//     prenom: 'Martin',
//     role: UserRole.USER_PARTENAIRE,
//     partenaire: 'axa',
//     actif: true
//   },
//   {
//     id: 4,
//     email: 'gestionnaire@maif.fr',
//     password: 'maif123',
//     nom: 'Pierre',
//     prenom: 'Durand',
//     role: UserRole.ADMIN_PARTENAIRE,
//     partenaire: 'maif',
//     actif: true
//   },
// ];